import React from 'react';
import Image from 'next/image';

// Simplified Card Component - only title and description, same style as original
export default function Card({ data, isOpen, onToggle }) {
  const title = data?.title || '';
  const description = data?.description || '';
  const imageUrl = data?.secondaryImage?.url || '';

  return (
    <article className="relative h-[244px] w-full overflow-hidden rounded lg:h-[390px]">
      {imageUrl && (
        <Image
          src={imageUrl}
          alt="background layer"
          fill
          className="max-h-[180px] !object-cover lg:max-h-[320px]"
          priority
        />
      )}

      <div
        data-open={isOpen}
        className={`overlay-card relative z-10 flex h-full w-full flex-col justify-start overflow-auto transition-transform ${
          isOpen
            ? 'transform-none'
            : 'translate-y-[calc(100%-78px)] lg:translate-y-[calc(100%-92px)]'
        } ${isOpen ? 'bg-text-accent' : 'bg-text-primary'}`}>
        <div
          data-open={isOpen}
          className="flex h-18 w-full flex-col justify-between p-6 text-text-invert lg:h-23 lg:p-7">
          <div className="flex w-full items-center justify-between">
            <button
              type="button"
              onClick={onToggle}
              aria-label={isOpen ? 'Collapse card' : 'Expand card'}
              className="flex w-full items-center justify-between">
              {title && (
                <h4
                  data-open={isOpen}
                  className="text-start font-normal leading-default !tracking-normal text-text-invert transition-all ltr:!text-clamp18to28 rtl:font-sans-ar rtl:!text-clamp18to28">
                  {title}
                </h4>
              )}

              <i
                className={`${isOpen ? 'rotate-180' : 'rotate-0'} one-central-arrow-small text-[9px] text-text-invert transition-transform duration-150`}
              />
            </button>
          </div>
        </div>
        <div className={`flex w-full flex-col px-6 ${isOpen ? 'mt-1 lg:-mt-3' : 'mt-2'}`}>
          {description && (
            <p
              className="text-start text-clamp12to18 font-extralight leading-medium !tracking-normal text-text-invert rtl:font-sans-ar [&>strong]:text-white"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      </div>
    </article>
  );
}
